<template>
  <ion-menu menu-id="app-menu" side="end" content-id="main-content" :disabled="menuOpenable">
    <ion-header>
      <ion-toolbar>
        <ion-title v-if="useAuthStore.user">
          {{
            useAuthStore.user.email
          }}
        </ion-title>
        <ion-title v-else>Birdiefy</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content v-if="useAuthStore.user" class="menu">
      <ion-list>
        <!-- <ion-item button @click="menuNavigation('/')">
          <ion-label>Home</ion-label>
        </ion-item>-->
        <!-- <ion-item button @click="menuNavigation('/register')">
          <ion-label>Register</ion-label>
        </ion-item>-->
        <ion-item button @click="clearSessions()" style="color: #dac23a">
          <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
            <title>Trash</title>
            <path d="M112 112l20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320" fill="none"
              stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
            <path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M80 112h352" />
            <path
              d="M192 112V72h0a23.93 23.93 0 0124-24h80a23.93 23.93 0 0124 24h0v40M256 176v224M184 176l8 224M328 176l-8 224"
              fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
          </svg>
          <ion-label>Delete all sessions</ion-label>
        </ion-item>
        <ion-item button @click="deleteUser()" style="color: #e48383">
          <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
            <title>Warning</title>
            <path
              d="M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z"
              fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
            <path d="M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z" fill="none"
              stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
            <path d="M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z" />
          </svg>
          <ion-label>Delete account</ion-label>
        </ion-item>
        <ion-item button @click="menuNavigation('dashboard')">
          <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
            <title>Grid</title>
            <rect x="48" y="48" width="176" height="176" rx="20" ry="20" fill="none" stroke="currentColor"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
            <rect x="288" y="48" width="176" height="176" rx="20" ry="20" fill="none" stroke="currentColor"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
            <rect x="48" y="288" width="176" height="176" rx="20" ry="20" fill="none" stroke="currentColor"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
            <rect x="288" y="288" width="176" height="176" rx="20" ry="20" fill="none" stroke="currentColor"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
          </svg>
          <ion-label>Dashboard</ion-label>
        </ion-item>
        <ion-item button @click="menuNavigation('settings')">
          <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
            <title>Settings</title>
            <path
              d="M262.29 192.31a64 64 0 1057.4 57.4 64.13 64.13 0 00-57.4-57.4zM416.39 256a154.34 154.34 0 01-1.53 20.79l45.21 35.46a10.81 10.81 0 012.45 13.75l-42.77 74a10.81 10.81 0 01-13.14 4.59l-44.9-18.08a16.11 16.11 0 00-15.17 1.75A164.48 164.48 0 01325 400.8a15.94 15.94 0 00-8.82 12.14l-6.73 47.89a11.08 11.08 0 01-10.68 9.17h-85.54a11.11 11.11 0 01-10.69-8.87l-6.72-47.82a16.07 16.07 0 00-9-12.22 155.3 155.3 0 01-21.46-12.57 16 16 0 00-15.11-1.71l-44.89 18.07a10.81 10.81 0 01-13.14-4.58l-42.77-74a10.8 10.8 0 012.45-13.75l38.21-30a16.05 16.05 0 006-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 00-6.07-13.94l-38.19-30A10.81 10.81 0 0149.48 186l42.77-74a10.81 10.81 0 0113.14-4.59l44.9 18.08a16.11 16.11 0 0015.17-1.75A164.48 164.48 0 01187 111.2a15.94 15.94 0 008.82-12.14l6.73-47.89A11.08 11.08 0 01213.23 42h85.54a11.11 11.11 0 0110.69 8.87l6.72 47.82a16.07 16.07 0 009 12.22 155.3 155.3 0 0121.46 12.57 16 16 0 0015.11 1.71l44.89-18.07a10.81 10.81 0 0113.14 4.58l42.77 74a10.8 10.8 0 01-2.45 13.75l-38.21 30a16.05 16.05 0 00-6.05 14.08c.33 4.14.55 8.3.55 12.47z"
              fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
          </svg>
          <ion-label>Settings</ion-label>
        </ion-item>

        <!-- <ion-item button @click="menuNavigation('friends')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            fill="#000000"
          >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path
              d="M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
            />
          </svg>
          <div style="position: relative;">
            <ion-label>Friends</ion-label>
            <ion-badge
              v-if="useFiredataStore.totalRequests > 0"
              :color="useFiredataStore.totalRequests >= 1 ? 'danger' : 'primary'"
              style="position: absolute; top: -9px; right:-15px;"
            >{{ useFiredataStore.totalRequests }}</ion-badge>
          </div>
        </ion-item> -->
        <ion-item button @click="signOut()">
          <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
            <title>Log Out</title>
            <path
              d="M304 336v40a40 40 0 01-40 40H104a40 40 0 01-40-40V136a40 40 0 0140-40h152c22.09 0 48 17.91 48 40v40M368 336l80-80-80-80M176 256h256"
              fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
          </svg>
          <ion-label>Sign out</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-content v-else>
      <ion-list>
        <ion-item button @click="menuNavigation('login')">
          <ion-label>Sign in</ion-label>
        </ion-item>
      </ion-list>
      <ion-list>
        <ion-item button @click="menuNavigation('register')">
          <ion-label>Create account</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>
</template>
<script>
import { getAuth, signOut, deleteUser, reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import {
  IonMenu,
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
  IonItem,
  IonList,
  IonLabel,
  menuController,
} from "@ionic/vue";

import { useToast } from "vue-toastification";
const toast = useToast();

import { authStore } from '../store/auth'
import { firedataStore } from '../store/firedata'
export default {
  name: "main-menu",
  setup() {
    const useAuthStore = authStore()
    const useFiredataStore = firedataStore()
    return { useAuthStore, useFiredataStore }
  },
  components: {
    IonMenu,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonItem,
    IonList,
    IonLabel
  },
  computed: {
    menuOpenable() {
      if (this.$route.name === "NewSession") return true;
      return false;
    }
  },
  methods: {
    async promptForCredentials() {

      const auth = getAuth();
      const user = auth.currentUser;
      const email = user.email;
      const password = prompt("Please re-enter your account password to delete your data and account:");
      const credential = EmailAuthProvider.credential(email, password);
      return credential;
    },
    async deleteUser() {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!confirm("Warning: this will delete your account and remove your data, please confirm again.")) return;
      localStorage.clear();

      const credential = await this.promptForCredentials();

      try {
        await reauthenticateWithCredential(user, credential);
        toast("Sucessfully reauthenticated user: " + user.email);
      } catch (error) {
        toast("Error reauthenticating user: " + error);
        return;
      }


      try {
        await this.useFiredataStore.resetAll();
      }
      catch (error) {
        toast("Error deleting user data: " + error);
      }

      deleteUser(user)
        .then(() => {
          toast("Sucessfully deleted user from database: " + user.email);
          menuController.close("app-menu");
          this.useFiredataStore.allSessions = [];
          this.$router.push("/");
        })
        .catch((error) => {
          toast("Error reauthenticating user: " + error);
        });
    },
    signOut() {
      const auth = getAuth();

      signOut(auth).then(() => {
        menuController.close("app-menu");
        this.useAuthStore.user = null;
        this.$router.push("/");

      })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          toast(errorCode);
          toast(errorMessage);
        });
    },
    menuNavigation(url) {
      menuController.close("app-menu");
      this.$router.push(url);
    },
    clearSessions() {
      if (confirm("Clear/remove all data? Cant regret this.")) {
        this.useFiredataStore.allSessions = [];
        this.useFiredataStore.resetAll();
        menuController.close("app-menu");
      }
    },

  },
  created() {
    setTimeout(() => {
      if (!this.useAuthStore.user) this.useAuthStore.authenticate();

    }, 300);
  },
};
</script>
<style>
ion-title {
  font-size: 0.9rem;
}

.menu svg {
  width: 17px;
  margin-right: 8px;
}
</style>